import React from 'react';
import { motion } from 'framer-motion';

interface StarAnimationProps {
  starCount?: number;
  className?: string;
}

const StarAnimation: React.FC<StarAnimationProps> = ({ 
  starCount = 50, 
  className = "absolute inset-0 overflow-hidden" 
}) => {
  return (
    <div className={className}>
      {[...Array(starCount)].map((_, i) => (
        <motion.div
          key={i}
          className="absolute w-1 h-1 bg-white rounded-full"
          style={{
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 100}%`,
          }}
          animate={{
            opacity: [0, 1, 0],
            scale: [0, 1, 0],
          }}
          transition={{
            duration: 2 + Math.random() * 3,
            repeat: Infinity,
            delay: Math.random() * 2,
          }}
        />
      ))}
    </div>
  );
};

export default StarAnimation; 